export const optionsEventFilterSelect = [
  {
    value: 1,
    label: 'Load.Task.ConditionsWhenOptionSubscribedEmail'
  },
  {
    value: 2,
    label: 'Load.Task.ConditionsWhenOptionSuspended'
  },
  {
    value: 3,
    label: 'Load.Task.ConditionsWhenOptionSubscribedSMS'
  },
  {
    value: 4,
    label: 'Load.Task.ConditionsWhenOptionLastClick'
  },
  {
    value: 5,
    label: 'Load.Task.ConditionsWhenOptionFilledFormAnyList'
  },
  {
    value: 6,
    label: 'Load.Task.ConditionsWhenOptionFilledFormCurrentList'
  }
]

export const triggerFieldTypeOptios = [
  {
    value: 1,
    label: 'Load.MailupCommon.Integer'
  },
  {
    value: 2,
    label: 'Load.MailupCommon.Decimal'
  },
  {
    value: 3,
    label: 'Load.MailupCommon.Character'
  },
  {
    value: 5,
    label: 'Load.MailupCommon.Date(dd/MM/yyyy)'
  },
  {
    value: 6,
    label: 'Load.MailupCommon.Date(dd/MM)'
  },
  {
    value: 7,
    label: 'Load.MailupCommon.Date(MM/dd/yyyy)'
  },
  {
    value: 8,
    label: 'Load.MailupCommon.Date(MM/dd)'
  },
  {
    value: 9,
    label: 'Load.MailupCommon.Date(yyyyMMdd)'
  },
  {
    value: 10,
    label: 'Load.MailupCommon.Date(MMdd)'
  },
  {
    value: 11,
    label: 'Load.MailupCommon.Date(yyyy-MM-dd)'
  },
  {
    value: 12,
    label: 'Load.MailupCommon.Date(YYYY-MM-DDThh:mm:ssTZD)'
  }
]

export const triggerFieldFilterOptions = [
  {
    value: 1,
    label: 'Load.MailupCommon.PersonalDataFilterCondition-1'
  },
  {
    value: 2,
    label: 'Load.MailupCommon.PersonalDataFilterCondition-2'
  },
  {
    value: 3,
    label: 'Load.MailupCommon.PersonalDataFilterCondition-3'
  },
  {
    value: 4,
    label: 'Load.MailupCommon.PersonalDataFilterCondition-4'
  },
  {
    value: 5,
    label: 'Load.MailupCommon.PersonalDataFilterCondition-5'
  },
  {
    value: 6,
    label: 'Load.MailupCommon.PersonalDataFilterCondition-6'
  },
  {
    value: 7,
    label: 'Load.MailupCommon.PersonalDataFilterCondition-7'
  },
  {
    value: 8,
    label: 'Load.MailupCommon.PersonalDataFilterCondition-8'
  },
  {
    value: 9,
    label: 'Load.MailupCommon.PersonalDataFilterCondition-9'
  },
  {
    value: 10,
    label: 'Load.MailupCommon.PersonalDataFilterCondition-10'
  },
  {
    value: 11,
    label: 'Load.MailupCommon.PersonalDataFilterCondition-11'
  },
  {
    value: 12,
    label: 'Load.MailupCommon.PersonalDataFilterCondition-12'
  },
  // { value: 13, label: 'Load.MailupCommon.PersonalDataFilterCondition-13' },
  // { value: 14, label: 'Load.MailupCommon.PersonalDataFilterCondition-14' },
  // { value: 15, label: 'Load.MailupCommon.PersonalDataFilterCondition-15' },
  // { value: 16, label: 'Load.MailupCommon.PersonalDataFilterCondition-16' },
  // { value: 17, label: 'Load.MailupCommon.PersonalDataFilterCondition-17' },
  {
    value: 18,
    label: 'Load.MailupCommon.PersonalDataFilterCondition-18'
  },
  {
    value: 19,
    label: 'Load.MailupCommon.PersonalDataFilterCondition-19'
  },
  {
    value: 20,
    label: 'Load.MailupCommon.PersonalDataFilterCondition-20'
  },
  {
    value: 21,
    label: 'Load.MailupCommon.PersonalDataFilterCondition-21'
  },
  {
    value: 22,
    label: 'Load.MailupCommon.PersonalDataFilterCondition-22'
  },
  {
    value: 23,
    label: 'Load.MailupCommon.PersonalDataFilterCondition-23'
  },
  {
    value: 24,
    label: 'Load.MailupCommon.PersonalDataFilterCondition-24'
  },
  {
    value: 25,
    label: 'Load.MailupCommon.PersonalDataFilterCondition-25'
  },
  {
    value: 26,
    label: 'Load.MailupCommon.PersonalDataFilterCondition-26'
  },
  {
    value: 27,
    label: 'Load.MailupCommon.PersonalDataFilterCondition-27'
  },
  {
    value: 28,
    label: 'Load.MailupCommon.PersonalDataFilterCondition-28'
  },
  {
    value: 29,
    label: 'Load.MailupCommon.PersonalDataFilterCondition-29'
  },
  {
    value: 30,
    label: 'Load.MailupCommon.PersonalDataFilterCondition-30'
  }
]
